import EmptyRouterView from './../views/functionary/EmptyRouterView.vue'
import Functionary from './../views/functionary/Home.vue'
import Questionnare from './../views/functionary/questionnarie/Home.vue'

export const routes = [
  { path: '/functionary', 
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'functionaryHome', 
        component: Functionary,
      },       
      {
        path: 'encuesta',
        name: 'questionary', 
        component: Questionnare,
      },       
    ]
  },
]